import cn from 'classnames';
import React, { useCallback, useEffect, useState } from 'react';

import { Button, Input } from '@.ui';

import { ListItemModel } from '../../../../../model/ListItemModel';
import S from './Listbox.module.scss';

interface ListboxProps {
    title: string;
    placeholder: string;

    items: ListItemModel[];

    selectItem: (item: ListItemModel) => void;
    unselectItem: (item: ListItemModel) => void;

    selectAll: () => void;
    unselectAll: () => void;
}

export function Listbox({ title, items, placeholder, unselectItem, selectItem, unselectAll, selectAll }: ListboxProps) {
    const [search, setSearch] = useState<string>('');

    const itemsToDisplay: ListItemModel[] = items.filter((item) => item.title.toLowerCase().includes(search.toLowerCase()));

    const isItemsEmpty = itemsToDisplay.length === 0;

    const createOnClickItemFn = useCallback(
        (item: ListItemModel) => {
            if (item.isDisabled) {
                return undefined;
            }

            if (item.isSelected) {
                return () => unselectItem({ ...item, isSelected: false });
            }

            return () => selectItem({ ...item, isSelected: true });
        },
        [selectItem, unselectItem]
    );

    const isSelectAllButtonEnabled = itemsToDisplay.length > 0;
    const isClearAllButtonEnabled = isSelectAllButtonEnabled && itemsToDisplay.some((item) => item.isSelected);

    return (
        <div className={S.form}>
            <Input className={S.searchInput} placeholder={placeholder} value={search} onChange={setSearch} />

            <div className={S.title}>{title}</div>

            <div className={S.list}>
                {!isItemsEmpty &&
                    itemsToDisplay.map((item) => (
                        <div
                            key={`${item.title}-${item.entityId}`}
                            className={cn(S.list__item, item.isSelected && S.list__item_selected, item.isDisabled && S.list__item_disabled)}
                            onClick={createOnClickItemFn(item)}
                        >
                            {item.title}
                        </div>
                    ))}

                {isItemsEmpty && <div className={cn(S.list__item, S.empty)}>The list is empty</div>}
            </div>

            <div className={S.buttons}>
                <Button color="brown" onClick={selectAll} disabled={!isSelectAllButtonEnabled}>
                    Select all
                </Button>
                <Button color="brown" onClick={unselectAll} disabled={!isClearAllButtonEnabled}>
                    Clear all
                </Button>
            </div>
        </div>
    );
}
